<template>
    <main class="main">
        <section class="delivery-sec account-sec">
            <div class="container">
                <div class="delivery-sec__banner">
                    <picture>
                        <source srcset="https://batnorton.com/img/delivery-baner.webp" type="image/webp">
                        <img src="https://batnorton.com/img/delivery-baner.jpg" class="img-element">
                    </picture>
                </div>
                <VipInfoBar
                    v-if="showVipBar"
                    class="user-account__vip-bar_mobile"
                    :discount-percent="vipDiscountPercent"
                />
                <MyAside :page="page"/>
                <component :is="componentName" :ga4-purchase="ga4Purchase" />
            </div>
        </section>
    </main>
    <AirOrder  ref="air"/>
</template>

<script>
import MyAside from './my-aside.vue'
import Personal from './personal.vue'
import History from './history.vue'
import Login from './login.vue'
import Register from './register.vue'
import AirOrder from '../../components/Airs/order.vue'
import VipInfoBar from './vip-info-bar.vue'

export default {

    props:{
        page:String,
        ga4Purchase: {
            type: Object,
            default: null,
        },
    },
    components: {
        MyAside, Personal, History, Login, Register, AirOrder, VipInfoBar,
    },
    name: "index",

    computed: {
        componentName() {
            return this.page
        },
        showVipBar() {
            return ['personal', 'history'].includes(this.page)
                && Boolean(this.$store.state.settings.user?.is_vip)
        },
        vipDiscountPercent() {
            return Number(this.$store.state.settings.vip_discount_percent) || 30
        },
    },
}
</script>

<style scoped>

</style>
